export const GOOGLE_ADS_TAG_ID = "AW-18332797557";
export const GOOGLE_ADS_ACCOUNT_CREATION_CONVERSION_LABEL = "smsZCOWH5dIcEPWU4aVE";
export const GOOGLE_ADS_ACCOUNT_CREATION_SEND_TO = `${GOOGLE_ADS_TAG_ID}/${GOOGLE_ADS_ACCOUNT_CREATION_CONVERSION_LABEL}`;
export const GOOGLE_ANALYTICS_MEASUREMENT_ID = "G-TYLFLPJER2";
